export default __webpack_public_path__ + "static/media/2-alimentando-a-alguien-que-lo-necesite.9decdae7.jpg";